import { useState, useEffect } from 'react';
import TeamsSDK, { TeamsContext } from '@/teams/TeamsSDK';

export type Platform = 'teams' | 'web';

export interface PlatformInfo {
  platform: Platform;
  teamsContext: TeamsContext | null;
  isReady: boolean;
}

export function usePlatform(): PlatformInfo {
  const [platform, setPlatform] = useState<Platform>('web');
  const [teamsContext, setTeamsContext] = useState<TeamsContext | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // 2026-09-04 — antes armaba aquí su propia carrera de 2s contra el SDK de Teams, duplicada e
    // independiente de la que también corría en `AuthProvider.tsx`. Ahora ambas consumen el mismo
    // punto único (`TeamsSDK.detectTeams`, cacheado a nivel módulo) — ver su doc-comment.
    let cancelled = false;
    TeamsSDK.detectTeams().then((ctx) => {
      if (cancelled) return;
      if (ctx) {
        setPlatform('teams');
        setTeamsContext(ctx);
      }
      setIsReady(true);
    });
    return () => { cancelled = true; };
  }, []);

  return { platform, teamsContext, isReady };
}
